/* nydo Black Weeks — Phasensteuerung
   Eine Quelle für alles: der Kalender aus der Section "Black Weeks · Steuerung".
   Vorschau im Shop: ?bw-phase=early   oder   ?bw-date=2026-11-12
*/
(function () {
  'use strict';

  /* Nur eine aktive Instanz: Der Theme-Editor lädt das Skript bei jeder Änderung neu.
     Ältere Instanzen beenden sich, sonst flackern Countdown und Phase zwischen altem und neuem Stand. */
  window.__bwRun = (window.__bwRun || 0) + 1;
  var RUN = window.__bwRun;
  function stale() { return RUN !== window.__bwRun; }

  var cfgEl = document.getElementById('bw-config');
  if (!cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var params   = new URLSearchParams(location.search);
  var forced   = params.get('bw-phase');
  var forcedAt = params.get('bw-date');
  var editor   = !!(window.Shopify && window.Shopify.designMode);
  var active   = CFG.active !== false;      /* Steuerung an/aus */
  var auto     = active || !!forced;        /* Vorschau per Parameter filtert immer */

  function ts(v) { var d = new Date(v); return isNaN(d) ? 0 : d.getTime(); }
  function now() { return forcedAt ? ts(forcedAt) : Date.now(); }

  /* Steuerung aus: Phase des ersten sichtbaren Hero-Blocks (für Hero-Bild, Countdown, Stufen) */
  function manualPhase() {
    var c = document.querySelector('[data-bw-hero] .bw-hero-copy');
    return c ? c.getAttribute('data-bw-phase') : 'ended';
  }

  function currentPhase() {
    if (forced) return forced;
    if (!active) return manualPhase();
    var t = now();
    for (var i = 0; i < CFG.phases.length; i++) {
      if (t <= ts(CFG.phases[i].to)) return CFG.phases[i].id;
    }
    return 'ended';
  }

  function inList(list, phase) {
    if (!list) return true;
    return ('' + list).split(',').some(function (x) { return x.trim() === phase; });
  }

  var cutoff = ts(CFG.cutoff);
  function deliveryPast() { return now() > cutoff; }
  function daysLeft() { return Math.max(0, Math.floor((cutoff - now()) / 86400000)); }   /* Texte: kommen aus der Section "Black Weeks · Bänder" (übersetzbar in Translate & Adapt). Die Tabelle hier ist nur der Rückfall, falls dort nichts ankommt. */ var LANG = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase(); var LOCALE = { de: 'de-CH', fr: 'fr-CH', en: 'en-GB' }[LANG] || 'de-CH'; var TXT_ALL = { de: { start: 'Start: {datum}, {zeit} Uhr', end: 'Ende: {datum}, {zeit} Uhr', deliveryTitle: 'Lieferung vor Weihnachten', daysOne: 'Noch {tage} Tag.', daysMany: 'Noch {tage} Tage.', newYear: 'Wunschtermin im neuen Jahr', counter: 'Noch {rest} von {gesamt} verfügbar', soon: 'Bald', hintOpen: 'Alle Preise inklusive Mehrwertsteuer, Lieferung und Montage.', hintLocked: 'Die Preise dieses Deals öffnen später. Bestelle Stoffmuster und sieh sie zuerst.', priceFrom: 'Preis ab {datum}', priceLockedBody: 'Stoffmuster bestellen und früher sehen.' }, fr: { start: "Début : {datum}, {zeit}", end: "Fin : {datum}, {zeit}", deliveryTitle: "Livraison avant Noël", daysOne: "Plus que {tage} jour.", daysMany: "Plus que {tage} jours.", newYear: "Livraison à la date souhaitée l'an prochain", counter: "Encore {rest} sur {gesamt} disponibles", soon: "Bientôt", hintOpen: "Tous les prix incluent la TVA, la livraison et le montage.", hintLocked: "Les prix de cette offre seront dévoilés plus tard. Commandez des échantillons de tissu pour les découvrir en premier.", priceFrom: "Prix dès le {datum}", priceLockedBody: "Commandez des échantillons de tissu pour les voir plus tôt." }, en: { start: 'Starts: {datum}, {zeit}', end: 'Ends: {datum}, {zeit}', deliveryTitle: 'Delivery before Christmas', daysOne: '{tage} day left.', daysMany: '{tage} days left.', newYear: 'Delivery on your date in the new year', counter: '{rest} of {gesamt} left', soon: 'Soon', hintOpen: 'All prices include VAT, delivery and assembly.', hintLocked: 'Prices for this deal open later. Order fabric samples to see them first.', priceFrom: 'Price from {datum}', priceLockedBody: 'Order fabric samples to see them earlier.' } }; var TXT = TXT_ALL[LANG] || TXT_ALL.de; var I18N = (function () { var el = document.querySelector('[data-bw-i18n]'); if (!el) return {}; try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; } })(); function tr(key, vars) { var s = I18N[key] || (TXT[key] != null ? TXT[key] : TXT_ALL.de[key]); if (vars) for (var k in vars) s = s.split('{' + k + '}').join(vars[k]); return s; }

  /* ---------- Sichtbarkeit ---------- */
  function applyVisibility(phase) {
    document.documentElement.setAttribute('data-bw-phase', phase);
    /* one section order for every phase — only visibility changes */
    document.querySelectorAll('[data-bw-phase]').forEach(function (el) {
      if (el === document.documentElement) return;
      el.hidden = (editor || !auto) ? false : !inList(el.getAttribute('data-bw-phase'), phase);
    });
  }

  /* ---------- Lieferhinweise ---------- */
  function deliveryCopy() {
    var el = document.querySelector('[data-bw-delivery-copy]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function applyDelivery() {
    var c = deliveryCopy(); if (!c) return;
    var past = deliveryPast(), d = daysLeft();
    document.querySelectorAll('[data-bw-band-delivery]').forEach(function (band) {
      band.textContent = past ? c.after : c.before;
      band.classList.toggle('is-past', past);
    });
    var inline = (past ? c.inlineAfter : c.inlineBefore || '').replace('{tage}', d);
    document.querySelectorAll('[data-bw-delivery], [data-bw-delivery-inline]').forEach(function (el) {
      el.textContent = inline;
      el.classList.toggle('is-past', past);
    });
    document.querySelectorAll('[data-bw-delivery-short]').forEach(function (el) {
      el.textContent = past ? c.shortAfter : c.shortBefore;
      el.classList.toggle('is-past', past);
    });

    var g2 = document.querySelector('[data-bw-g2-after]');
    if (g2 && past) {
      var a; try { a = JSON.parse(g2.textContent); } catch (e) { return; }
      var t = document.querySelector('[data-bw-g2-title]');
      var b = document.querySelector('[data-bw-g2-body]');
      var dl = document.querySelector('[data-bw-g2-deadline]');
      if (t) t.textContent = a.title;
      if (b) b.textContent = a.body;
      if (dl) dl.textContent = a.deadline;
    }
  }

  /* ---------- Flash ---------- */
  function applyFlash() {
    var t = now();
    document.querySelectorAll('[data-bw-flash]').forEach(function (el) {
      el.hidden = (editor || !auto) ? false : !(t >= ts(CFG.flash.from) && t <= ts(CFG.flash.to));
    });
  }


  /* ---------- Countdown ---------- */
  var CDS = (function () {
    var el = document.querySelector('[data-bw-countdowns]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  })();

  function pad(n) { return String(n).padStart(2, '0'); }

  function tickCountdown(phase) {
    var box = document.querySelector('[data-bw-countdown]'); if (!box) return;
    var cd = CDS.filter(function (x) { return x.phase === phase; })[0];
    if (!cd || !cd.target) { box.hidden = true; return; }
    box.hidden = false;

    var target = cd.target, label = cd.label, t = now();
    if (cd.target2 && t >= ts(cd.target)) { target = cd.target2; label = cd.label2; }

    var diff = Math.max(0, ts(target) - t);
    if (diff <= 0) { box.hidden = true; return; }   /* abgelaufen: kein 00:00:00 zeigen */
    var set = function (k, v) {
      var e = box.querySelector('[data-bw-cd="' + k + '"]'); if (e) e.textContent = pad(v);
    };
    set('d', Math.floor(diff / 86400000));
    set('h', Math.floor(diff / 3600000) % 24);
    set('m', Math.floor(diff / 60000) % 60);
    set('s', Math.floor(diff / 1000) % 60);

    var lab = box.querySelector('[data-bw-cd-label]');
    if (lab) lab.textContent = label || '';
    var end = box.querySelector('[data-bw-cd-end]');
    if (end) {
      var opening = /beginnt|öffnet|starte|démarr|commenc|ouvr|begin|start|open/i.test(label || '');
      var dt = new Date(ts(target));
      end.textContent = tr(opening ? 'start' : 'end', { datum: dt.toLocaleDateString(LOCALE, { weekday: 'long', day: 'numeric', month: 'long' }), zeit: dt.toLocaleTimeString(LOCALE, { hour: '2-digit', minute: '2-digit' }) });
        
        
    }
  }

  /* ---------- Stufen, Sneak, Produktraster ---------- */
  var selected = 0;

  function sneakPhases() {
    var sec = document.querySelector('[data-bw-section="tiers"]');
    return sec ? (sec.getAttribute('data-sneak-phases') || 'teaser,swatch') : '';
  }

  function applyTiers(phase) {
    var sec = document.querySelector('[data-bw-section="tiers"]');
    var sneak = inList(sneakPhases(), phase);

    document.querySelectorAll('[data-bw-swap]').forEach(function (el) {
      if (!el.dataset.bwOriginal) el.dataset.bwOriginal = el.textContent;
      var alt; try { alt = JSON.parse(el.getAttribute('data-bw-swap')); } catch (e) { alt = ''; }
      el.textContent = (sneak && alt) ? alt : el.dataset.bwOriginal;
    });

    document.querySelectorAll('.bw-tier').forEach(function (card) {
      var i = +card.getAttribute('data-bw-tier');
      var pct = card.querySelector('[data-bw-pct]');
      var badge = card.querySelector('[data-bw-badge]');
      var lock = card.querySelector('[data-bw-locked]');
      var open = lock && inList(lock.getAttribute('data-open-phases'), phase) && !sneak;

      if (pct) {
        pct.textContent = sneak ? (pct.getAttribute('data-sneak') || '?? %') : pct.getAttribute('data-value');
        pct.classList.toggle('is-masked', sneak);
      }
      if (badge && !badge.dataset.bwOriginal) badge.dataset.bwOriginal = badge.textContent;
      if (badge) badge.textContent = sneak ? (badge.getAttribute('data-sneak') || tr('soon')) : badge.dataset.bwOriginal;

      if (lock) {
        lock.hidden = open;
        if (!open) {
          var t = sneak ? lock.getAttribute('data-sneak-title') : lock.getAttribute('data-locked-title');
          var b = sneak ? lock.getAttribute('data-sneak-body')  : lock.getAttribute('data-locked-body');
          lock.innerHTML = '<b>' + (t || '') + '</b>' + (b || '');
        }
      }
      card.setAttribute('aria-pressed', String(i === selected));
      card.dataset.bwOpen = open ? '1' : '0';
    });

    applyOffer(phase, sneak);
    applyPanels(phase, sneak);
  }

  function applyOffer(phase, sneak) {
    var slot = document.querySelector('[data-bw-perk-offer]');
    var src = document.querySelector('[data-bw-offers]');
    if (!slot || !src) return;
    var all; try { all = JSON.parse(src.textContent); } catch (e) { return; }
    var o = all[phase];
    if (!o) { slot.innerHTML = ''; return; }
    var html = '<strong>' + o.t + '</strong>' + o.b;
    if (o.counter && CFG.counter) {
      var left = CFG.counter.left, total = CFG.counter.total || 100;
      var pctDone = Math.max(0, Math.min(100, Math.round((total - left) / total * 100)));
      html += '<span class="bw-cnt"><span class="bw-cnt-bar"><i style="width:' + pctDone + '%"></i></span>'
            + '<b>' + tr('counter', { rest: left, gesamt: total }) + '</b></span>';
    }
    slot.innerHTML = html;

    var dslot = document.querySelector('[data-bw-perk-delivery]');
    var c = deliveryCopy();
    if (dslot && c) {
      dslot.innerHTML = deliveryPast()
        ? '<strong>' + tr('newYear') + '</strong>' + c.shortAfter
        : '<strong>' + tr('deliveryTitle') + '</strong>' + tr(daysLeft() === 1 ? 'daysOne' : 'daysMany', { tage: daysLeft() }) + ' ' + c.shortBefore + '.';
    }
  }

  function applyPanels(phase, sneak) {
    var panels = document.querySelectorAll('[data-bw-tier-panel]');
    if (!panels.length) return;
    var opened = document.querySelector('.bw-tier[data-bw-tier="' + selected + '"]');
    var isOpen = opened ? opened.dataset.bwOpen === '1' : false;

    panels.forEach(function (p) {
      var i = +p.getAttribute('data-bw-tier-panel');
      var bwScope = p.closest('[data-bw-only-selected]'); var bwOnly = !bwScope || bwScope.getAttribute('data-bw-only-selected') !== 'false'; p.hidden = bwOnly ? i !== selected : false;
      if (i !== selected) return;

      var head = document.querySelector('[data-bw-detail-head]');
      var sub  = document.querySelector('[data-bw-detail-sub]');
      var hint = document.querySelector('[data-bw-detail-hint]');
      var all  = document.querySelector('[data-bw-all]');
      if (head) head.textContent = p.getAttribute('data-head') || '';
      if (sub)  sub.textContent  = (sneak && p.getAttribute('data-sneak-sub')) || p.getAttribute('data-sub') || '';
      if (all)  { all.textContent = p.getAttribute('data-all-label') || ''; all.href = p.getAttribute('data-all-href') || '#'; }
      if (hint) hint.textContent = isOpen
        ? tr('hintOpen')
        : tr('hintLocked');

      p.querySelectorAll('[data-bw-price]').forEach(function (e) { e.hidden = !isOpen; });
      p.querySelectorAll('[data-bw-price-locked]').forEach(function (e) {
        e.hidden = isOpen;
        if (!isOpen) {
          var lock = opened ? opened.querySelector('[data-bw-locked]') : null;
          e.innerHTML = '<b>' + tr('priceFrom', { datum: lock ? lock.getAttribute('data-opens-on') : '' }) + '</b>'
            + tr('priceLockedBody');
        }
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (stale()) return;
    var card = e.target.closest ? e.target.closest('.bw-tier') : null;
    if (!card) return;
    selected = +card.getAttribute('data-bw-tier');
    applyTiers(currentPhase());
    var d = document.getElementById('detail');
    if (d) d.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });

  /* ---------- Anmeldung: nach dem Absenden weiter zur Musterauswahl ---------- */
  var form = document.getElementById('bw-signup-form');
  if (form) {
    form.addEventListener('submit', function () {
      var mail = document.getElementById('bw-mail');
      var to = mail && mail.getAttribute('data-bw-redirect');
      if (to) { try { sessionStorage.setItem('bw-redirect', to); } catch (err) {} }
    });
    try {
      var back = sessionStorage.getItem('bw-redirect');
      if (back && form.querySelector('.bw-note-ok')) { sessionStorage.removeItem('bw-redirect'); location.href = back; }
    } catch (err) {}
  }

  /* ---------- Start ---------- */
  function applyHero(phase) {
    var hero = document.querySelector('[data-bw-hero]'); if (!hero) return;
    var copy = hero.querySelector('.bw-hero-copy[data-bw-phase="' + phase + '"]')
            || hero.querySelector('.bw-hero-copy:not([hidden])');
    if (!copy) return;
    hero.classList.toggle('is-cyber', copy.getAttribute('data-theme') === 'cyber');
    var bg = copy.getAttribute('data-bg');
    hero.style.setProperty('--bw-hero-image', bg ? 'url("' + bg + '")' : 'none');
  }

  function renderAll() {
    var phase = currentPhase();
    applyVisibility(phase);
    applyHero(phase);
    applyDelivery();
    applyFlash();
    applyTiers(phase);
    tickCountdown(phase);
  }

  renderAll();
  var tick = setInterval(function () {
    if (stale()) { clearInterval(tick); clearInterval(full); return; }
    tickCountdown(currentPhase());
  }, 1000);
  var full = setInterval(function () { if (!stale()) renderAll(); }, 60000);
  document.addEventListener('shopify:section:load', function () { if (!stale()) renderAll(); }); document.addEventListener('shopify:block:select', function (e) { if (stale() || !e.target || !e.target.closest) return; var el = e.target.closest('[data-bw-tier-panel], .bw-tier') || e.target.querySelector('[data-bw-tier-panel], .bw-tier'); if (!el) return; var v = el.getAttribute('data-bw-tier-panel'); if (v === null) v = el.getAttribute('data-bw-tier'); if (v === null) return; selected = +v; applyTiers(currentPhase()); });
})();
